(function () {
  var API_BASE = 'https://admin.print-foundry.com/api/public/reviews';
  var STORE_NAME = 'gymtier';
  var MAX_HANDLES_PER_REQUEST = 35;
  var reviewCache = new Map();
  var loadingHandles = new Set();
  var scanTimer = null;

  function normaliseHandle(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/^\/+|\/+$/g, '');
  }

  function handleFromUrl(value) {
    if (!value) return '';
    try {
      var url = new URL(value, window.location.origin);
      var match = url.pathname.match(/\/products\/([^/?#]+)/);
      return match ? normaliseHandle(decodeURIComponent(match[1])) : '';
    } catch (error) {
      var fallback = String(value).match(/\/products\/([^/?#]+)/);
      return fallback ? normaliseHandle(decodeURIComponent(fallback[1])) : '';
    }
  }

  function parseJsonProduct(card) {
    var raw = card && card.getAttribute('data-json-product');
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (error) {
      return null;
    }
  }

  function cardHandle(card) {
    if (!card) return '';

    var direct = normaliseHandle(card.getAttribute('data-product-handle'));
    if (direct) return direct;

    var productData = parseJsonProduct(card);
    var jsonHandle = normaliseHandle(productData && (
      productData.handle ||
      productData.productHandle ||
      productData.product_handle
    ));
    if (jsonHandle) return jsonHandle;

    var child = card.querySelector('[data-product-handle]');
    var childHandle = normaliseHandle(child && child.getAttribute('data-product-handle'));
    if (childHandle) return childHandle;

    var titleLink = card.querySelector('.card-title[href], .custom-related-product-card__link[href], a[href*="/products/"]');
    return handleFromUrl(titleLink && titleLink.getAttribute('href'));
  }

  function cardTitleNode(card) {
    return card.querySelector('.card-title') ||
      card.querySelector('.custom-related-product-card__title') ||
      card.querySelector('.card__heading') ||
      card.querySelector('.card-information__wrapper');
  }

  function ensureReviewNode(card, handle) {
    var existing = card.querySelector('[data-gymtier-card-review]');
    if (existing) {
      if (handle) existing.setAttribute('data-review-handle', handle);
      return existing;
    }

    var node = document.createElement('div');
    node.className = 'gymtier-card-review';
    node.setAttribute('data-gymtier-card-review', '');
    node.setAttribute('data-review-handle', handle);
    node.hidden = true;
    node.innerHTML =
      '<span class="gymtier-card-review__stars" aria-hidden="true"></span>' +
      '<span class="gymtier-card-review__average"></span>' +
      '<span class="gymtier-card-review__count"></span>';

    var title = cardTitleNode(card);
    var price = card.querySelector('.card-price, .custom-related-product-card__price');

    if (title && title.parentNode) {
      title.insertAdjacentElement('afterend', node);
    } else if (price && price.parentNode) {
      price.parentNode.insertBefore(node, price);
    } else {
      card.appendChild(node);
    }

    return node;
  }

  function reviewNodesForHandle(handle) {
    return Array.prototype.slice.call(document.querySelectorAll('[data-gymtier-card-review][data-review-handle="' + window.CSS.escape(handle) + '"]'));
  }

  function starText(rating) {
    var value = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
    return '\u2605\u2605\u2605\u2605\u2605'.slice(0, value) + '\u2606\u2606\u2606\u2606\u2606'.slice(0, 5 - value);
  }

  function renderReviewNode(node, stats) {
    var count = Number(stats && stats.count) || 0;
    var average = Number(stats && stats.average) || 0;

    if (!count) {
      node.hidden = true;
      return;
    }

    var countLabel = count.toLocaleString('en-GB') + ' review' + (count === 1 ? '' : 's');
    var stars = node.querySelector('.gymtier-card-review__stars');
    var averageEl = node.querySelector('.gymtier-card-review__average');
    var countEl = node.querySelector('.gymtier-card-review__count');

    if (stars) stars.textContent = starText(average);
    if (averageEl) averageEl.textContent = average.toFixed(1);
    if (countEl) countEl.textContent = '(' + count.toLocaleString('en-GB') + ')';

    node.hidden = false;
    node.setAttribute('aria-label', average.toFixed(1) + ' out of 5 stars from ' + countLabel);
  }

  function renderHandle(handle, stats) {
    reviewNodesForHandle(handle).forEach(function (node) {
      renderReviewNode(node, stats);
    });
  }

  function fetchSummaries(handles) {
    if (!handles.length) return Promise.resolve();

    handles.forEach(function (handle) {
      loadingHandles.add(handle);
    });

    var params = new URLSearchParams({
      storeName: STORE_NAME,
      productHandles: handles.join(','),
      includeBundleComponents: '0'
    });

    return fetch(API_BASE + '/summaries?' + params.toString(), {
      credentials: 'omit',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Review summaries unavailable.');
        return response.json();
      })
      .then(function (payload) {
        var seen = new Set();
        (Array.isArray(payload && payload.items) ? payload.items : []).forEach(function (item) {
          var handle = normaliseHandle(item && item.productHandle);
          if (!handle) return;
          seen.add(handle);
          reviewCache.set(handle, item.stats || null);
          renderHandle(handle, item.stats || null);
        });

        handles.forEach(function (handle) {
          if (seen.has(handle)) return;
          reviewCache.set(handle, null);
          renderHandle(handle, null);
        });
      })
      .catch(function () {
        handles.forEach(function (handle) {
          reviewCache.set(handle, null);
          renderHandle(handle, null);
        });
      })
      .finally(function () {
        handles.forEach(function (handle) {
          loadingHandles.delete(handle);
        });
      });
  }

  function cardCandidates() {
    return Array.prototype.slice.call(document.querySelectorAll(
      '.product-item, .custom-related-product-card, .product__list-vertical .product, [data-product-handle][class*="card"]'
    ));
  }

  function scanCards() {
    var missing = [];
    var seen = new Set();

    cardCandidates().forEach(function (card) {
      var handle = cardHandle(card);
      if (!handle) return;

      var node = ensureReviewNode(card, handle);
      if (reviewCache.has(handle)) {
        renderReviewNode(node, reviewCache.get(handle));
        return;
      }

      if (loadingHandles.has(handle) || seen.has(handle)) return;
      seen.add(handle);
      missing.push(handle);
    });

    for (var index = 0; index < missing.length; index += MAX_HANDLES_PER_REQUEST) {
      fetchSummaries(missing.slice(index, index + MAX_HANDLES_PER_REQUEST));
    }
  }

  function scheduleScan() {
    window.clearTimeout(scanTimer);
    scanTimer = window.setTimeout(scanCards, 80);
  }

  function init() {
    scanCards();

    if (window.MutationObserver) {
      new MutationObserver(scheduleScan).observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    document.addEventListener('shopify:section:load', scheduleScan);
    document.addEventListener('collection:updated', scheduleScan);
  }

  if (!window.CSS || typeof window.CSS.escape !== 'function') {
    window.CSS = window.CSS || {};
    window.CSS.escape = function (value) {
      return String(value).replace(/"/g, '\\"');
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
